// extracted by mini-css-extract-plugin
export default {"panel":"geofence-item_panel__mWNy7","name":"geofence-item_name__xwBt3","form":"geofence-item_form__O-b4u"};